import React from "react";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  classOptions,
  nextSessionOptions,
  sessionOption,
} from "../../utils/helpers";
import CustomSelect from "../../Shared/CustomSelect";
import SubmitForm from "../../Shared/SubmitForm";
const StudentPromotion = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Students</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Student Promotion</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>Search Student Promotion</h3>
            </div>
            <Cta />
          </div>
          <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Current Session *"}
                  register={register}
                  errors={errors}
                  name={"session"}
                  placeholder={"Select Session"}
                  option={sessionOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Promotion Session *"}
                  register={register}
                  errors={errors}
                  name={"session"}
                  placeholder={"Select Session"}
                  option={nextSessionOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Promotion From Class *"}
                  register={register}
                  errors={errors}
                  name={"class"}
                  placeholder={"Select Class"}
                  option={classOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Promotion To Class *"}
                  register={register}
                  errors={errors}
                  name={"class"}
                  placeholder={"Select Class"}
                  option={classOptions}
                />
              </div>
              <SubmitForm />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default StudentPromotion;
